import { CourseDocumentApi, courseDocumentsApi } from "api/courseDocumentsApi";
import { IDropdownOption } from "components/atoms";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";

export const useCourseDocuments = (courseId: string | number) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_DOCUMENTS(courseId),
    queryFn: () => courseDocumentsApi.fetch(Number(courseId)),
    enabled: !!courseId,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return {
    loading: isLoading,
    data: data?.data ?? [],
    refresh: refetch,
  };
};

export interface CourseDocumentOption extends IDropdownOption {
  courseDocument: CourseDocumentApi | null;
  /** 1 = Dokumenty 1.0 (has a `template`), 2 = Dokumenty 2.0 (`template` is null, see `courseDocument.v2`). */
  version: 1 | 2;
}
export const useCourseDocumentsOptions = (courseId: string | number) => {
  const { loading, data } = useCourseDocuments(courseId);

  const options: CourseDocumentOption[] = data?.map((x) => ({
    value: x.id.toString(),
    label: x.name,
    courseDocument: x,
    // An API that predates Dokumenty 2.0 sends no version: those are all 1.0 documents.
    version: x.version === 2 ? 2 : 1,
  }));

  return { loading, options };
};
